import { Trans } from "react-i18next";

import { css } from "@emotion/react";

import {
    CommunicationIcon,
    InfoOutlineIcon
} from "@dotnet/telematics-design-system";

import LogoIcon from "assets/customIcons/contacts/LogoIcon";
import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import {
    CROWD_SUPPORT_FORUM,
    TELTONIKA_TELEMATICS_WEBSITE,
    TELTONIKA_WIKI_FOTA_WEB
} from "shared/constants/externalLinks";
import { useTranslatedExternalLinks } from "shared/hooks/useTranslatedExternalLinks";
import { body3SemiBold } from "shared/styles/typography";

import IconLink from "./IconLink";

const Contacts = () => {
    const { privacyPolicy } = useTranslatedExternalLinks();

    return (
        <div
            css={css({
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                columnGap: "16px",
                marginTop: "64px"
            })}
        >
            <div css={[body3SemiBold, { maxWidth: "208px" }]}>
                <Trans
                    i18nKey="Auth##privacy policy"
                    components={{
                        1: (
                            <TextLink
                                href={privacyPolicy}
                                target="_blank"
                                size={TEXT_LINK_SIZES.Small}
                            >
                                Privacy policy
                            </TextLink>
                        )
                    }}
                />
            </div>

            <div
                css={css({
                    display: "flex",
                    alignItems: "center",

                    "& > a + a": {
                        marginLeft: "16px"
                    }
                })}
            >
                <IconLink
                    link={TELTONIKA_TELEMATICS_WEBSITE}
                    tooltip="teltonika telematics"
                    icon={<LogoIcon />}
                />

                <IconLink
                    link={CROWD_SUPPORT_FORUM}
                    tooltip="community forum"
                    icon={<CommunicationIcon />}
                />

                <IconLink
                    link={TELTONIKA_WIKI_FOTA_WEB}
                    tooltip="wiki"
                    icon={<InfoOutlineIcon />}
                />
            </div>
        </div>
    );
};

export default Contacts;
